import React, {useState, useEffect} from "react";
import {
  Home,
  Dashboard
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';

import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import AuthProvider from './auth/AuthContext';
import Login from './auth/Login';
import ProtectedRoute from './ProtectedRoute';
import Users from "./pages/Users";

const AuthProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const navigate = useNavigate();
    return <AuthProvider navigate={navigate}>{children}</AuthProvider>;
  };

  
function App() {
    const [mode, setMode] = useState<string>('light');

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
        <Router>
            <AuthProviderWrapper>
                
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/digitalarchiving" element={<Login />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/users" element={
                            <ProtectedRoute>
                                <Users />
                            </ProtectedRoute>} />
                </Routes>
                
            </AuthProviderWrapper>
        </Router>
    );
}

export default App;